module.exports = __webpack_public_path__ + "1792395595471/fonts/WorkSans-Medium.e0522d9.woff";